// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Sunucular',
  subtitle: 'Tüm hosting sunucularını yönetin',
  server: 'Sunucu',
  newServer: 'Yeni Sunucu',
  addServer: 'Sunucu Ekle',
  editServer: 'Sunucu Düzenle',
  updateServer: 'Sunucu Güncelle',
  serverList: 'Sunucu Listesi',
  serverName: 'Sunucu Adı',
  ipAddress: 'IP Adresi',
  hostname: 'Hostname',
  provider: 'Sağlayıcı',
  plan: 'Plan',
  cost: 'Maliyet',
  paymentFrequency: 'Ödeme Sıklığı',
  expiryDate: 'Bitiş Tarihi',
  status: 'Durum',
  uptime: 'Uptime',
  lastCheck: 'Son kontrol',
  noServers: 'Henüz sunucu yok',
  noServersDesc: 'İlk sunucunuzu ekleyerek başlayın.',
  serverAdded: 'Sunucu başarıyla eklendi',
  serverUpdated: 'Sunucu başarıyla güncellendi',
  serverDeleted: 'Sunucu başarıyla silindi',
  fetchError: 'Sunucular alınamadı',
  addError: 'Sunucu eklenemedi',
  updateError: 'Sunucu güncellenemedi',
  deleteError: 'Sunucu silinemedi',
  confirmDelete: 'Bu sunucuyu silmek istediğinizden emin misiniz?',
  uptimeToggleError: 'IP adresi veya hostname olmadan uptime monitoring aktif edilemez',
  uptimeEnabled: 'Uptime monitoring aktif edildi',
  uptimeDisabled: 'Uptime monitoring pasif edildi',
  uptimeToggleError2: 'Uptime durumu güncellenemedi',
  ipOrHostnameRequired: 'IP adresi veya hostname gerekli',
  uptimeActive: 'Uptime monitoring aktif',
  uptimePassive: 'Uptime monitoring pasif'
};
